{
  "addons.addonList": "Список додатків",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Створіть і отримайте свій ключ API за цим посиланням",
  "addons.ambientWeatherDescription": "Метеостанції навколишнього середовища (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Ключ API",
  "addons.applicationKey": "Ключ програми",
  "addons.connect": "Підключитися",
  "addons.davisApiSecret": "Секрет API",
  "addons.davisApiV2Key": "Ключ API V2",
  "addons.davisDescription": "Метеостанції Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Отримайте свої ключі API V2 за цим посиланням",
  "addons.disconnect": "Відключити",
  "addons.ecowittCreateAndRetrieveKeys": "Створіть і отримайте як ключ API, так і ключ програми за цим посиланням",
  "addons.ecowittDescription": "Ecowitt пропонує професійну метеостанцію Wi-Fi, бездротові термометри для приміщень на відкритому повітрі, монітори вологості, високоточні датчики дощу, монітори якості повітря тощо.",
  "addons.helpLink": "Як підключити {provider}",
  "addons.myAcuriteAccountOnHold": "Ваш обліковий запис призупинено. Будь ласка, введіть свій пароль, щоб повторно підключити обліковий запис",
  "addons.myAcuriteDescription": "AcuRite є брендом метеостанцій №1 у Північній Америці. Будучи лідером у галузі технологій часу, температури та погоди, AcuRite надає вам детальну інформацію про ваше середовище в приміщенні та на вулиці, щоб ви могли впевнено планувати свій день.",
  "addons.myAcuriteEnterCredentials": "Введіть свої облікові дані My AcuRite, щоб зв’язати обліковий запис My AcuRite зі SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Використовуйте свій термостат Netatmo, щоб змінювати температуру вдома, перебуваючи в ліжку чи з іншого боку світу.",
  "addons.netatmoThermostat": "Термостат Netatmo",
  "addons.netatmoWeather": "Погода Netatmo",
  "addons.netatmoWeatherDescription": "Ваша персональна метеостанція вдома",
  "addons.or": "або",
  "addons.providerAccountDisconnected": "З'єднання з вашою метеослужбою закінчилося. Будь ласка, підключіться знову, щоб відновити оновлення даних.",
  "addons.reconnect": "Повторне підключення",
  "addons.weatherflowCreateToken": "Створіть і отримайте свій маркер за цим посиланням",
  "addons.weatherflowTempestDescription": "Система Tempest Weather із вбудованим лічильником вітру та дощоміром",
  "addons.wundergroundApiKey": "Ключ API",
  "addons.wundergroundDescription": "Weather Underground — це глобальна спільнота людей, які об’єднують дані з датчиків навколишнього середовища, як-от метеостанцій і моніторів якості повітря, щоб ми могли надавати різноманітні гіперлокальні дані, необхідні для ваших пристрастей",
  "addons.wundergroundRetrieveApiKey": "Отримайте свій ключ API за цим посиланням",
  "addons.wundergroundRetrieveStationId": "Отримайте ідентифікатор вашої станції за цим посиланням",
  "addons.wundergroundStationId": "ID станції",
  "airQuality.airQuality": "Якість повітря",
  "airQuality.airQualityIndex": "Індекс якості повітря",
  "airQuality.aqiForecast": "Прогноз якості повітря",
  "airQuality.co": "Окис вуглецю",
  "airQuality.dailyForecast": "Щоденний прогноз",
  "airQuality.details": "Подробиці",
  "airQuality.dominantPollutant": "Основний забруднювач",
  "airQuality.good": "добре",
  "airQuality.goodDescription": "Якість повітря вважається задовільною, а забруднення повітря не становить небезпеки або не становить нічого",
  "airQuality.hazardous": "небезпечний",
  "airQuality.hazardousDescription": "Попередження про здоров’я: будь-хто може мати більш серйозні наслідки для здоров’я",
  "airQuality.indoorAirQuality": "Якість повітря в приміщенні",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Помірний",
  "airQuality.moderateDescription": "Якість повітря прийнятна; однак деякі забруднювачі можуть викликати помірне занепокоєння для здоров'я дуже невеликої кількості людей, які надзвичайно чутливі до забруднення повітря.",
  "airQuality.no2": "Діоксид азоту",
  "airQuality.o3": "Озон",
  "airQuality.pm10": "Частинки діаметром 10 мкм або менше",
  "airQuality.pm25": "Частинки діаметром 2,5 мкм або менше",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Нездоровий для чутливих людей",
  "airQuality.sensitiveUnhealthyDescription": "Члени чутливих груп можуть мати наслідки для здоров'я. Це навряд чи вплине на широку громадськість.",
  "airQuality.so2": "Діоксид сірки",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Нездоровий",
  "airQuality.unhealthyDescription": "Кожен може почати відчувати вплив на здоров'я; члени чутливих груп можуть мати більш серйозні наслідки для здоров'я",
  "airQuality.veryUnhealthy": "Дуже нездоровий",
  "airQuality.veryUnhealthyDezscription": "Медичні попередження про надзвичайні ситуації. Більша ймовірність ураженості всього населення.",
  "alerts.addAlert": "Додати сповіщення",
  "alerts.addCondition": "Додайте умову",
  "alerts.alertAdded": "Сповіщення успішно додано",
  "alerts.alertAuthorizationNotice": "Сповіщення працюють, лише якщо ви дозволили SmartMixin відображати сповіщення",
  "alerts.alertDeleted": "Сповіщення успішно видалено",
  "alerts.alertEdited": "Сповіщення успішно змінено",
  "alerts.alertName": "Назва сповіщення",
  "alerts.alertWhen": "Я хочу отримувати сповіщення, коли:",
  "alerts.aqiGreaterThan": "AQI більше ніж",
  "alerts.aqiGreaterThanThreshold": "AQI перевищує порогове значення {value}{unit}",
  "alerts.aqiLessThan": "AQI менше ніж",
  "alerts.aqiLessThanThreshold": "AQI менший за порогове значення {value}{unit}",
  "alerts.atLeastOneCondition": "Потрібно додати хоча б одну умову",
  "alerts.co2GreaterThan": "CO2 більше ніж",
  "alerts.co2GreaterThanThreshold": "CO2 перевищує порогове значення {value}{unit}",
  "alerts.co2LessThan": "CO2 менше ніж",
  "alerts.co2LessThanThreshold": "CO2 менший за порогове значення {value}{unit}",
  "alerts.conditions": "Умови",
  "alerts.createAlert": "Створити сповіщення",
  "alerts.dailyPrecipitationGreaterThan": "Добові опади більше ніж",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Добові опади перевищують поріг {value}{unit}",
  "alerts.deleteAlert": "Видалити сповіщення",
  "alerts.editAlert": "Редагувати сповіщення",
  "alerts.editCondition": "Редагувати умову",
  "alerts.gustSpeedGreaterThan": "Швидкість пориву більше ніж",
  "alerts.gustSpeedGreaterThanThreshold": "Швидкість поривів перевищує порогове значення {value}{unit}",
  "alerts.gustSpeedLessThan": "Швидкість пориву менше ніж",
  "alerts.gustSpeedLessThanThreshold": "Швидкість поривів менша за порогове значення {value}{unit}",
  "alerts.heatIndexGreaterThan": "Індекс тепла більший за",
  "alerts.heatIndexGreaterThanThreshold": "Індекс тепла перевищує порогове значення {value}{unit}",
  "alerts.heatIndexLessThan": "Індекс тепла менший за",
  "alerts.heatIndexLessThanThreshold": "Індекс тепла нижчий за порогове значення {value}{unit}",
  "alerts.humidexGreaterThan": "Гумідекс більший за",
  "alerts.humidexGreaterThanThreshold": "Гумідекс перевищує порогове значення {value}{unit}",
  "alerts.humidexLessThan": "Гумідекс менший за",
  "alerts.humidexLessThanThreshold": "Гумідекс нижчий за порогове значення {value}{unit}",
  "alerts.humidityGreaterThan": "Вологість більше ніж",
  "alerts.humidityGreaterThanThreshold": "Вологість перевищує порогове значення {value}{unit}",
  "alerts.humidityLessThan": "Вологість менше ніж",
  "alerts.humidityLessThanThreshold": "Вологість менше ніж порогове значення {value}{unit}",
  "alerts.inProgress": "В процесі",
  "alerts.myAlerts": "Мої сповіщення",
  "alerts.noConfiguredAlert": "У вас ще немає налаштованих сповіщень, почніть додавати одне",
  "alerts.noiseGreaterThan": "Шум більше ніж",
  "alerts.noiseGreaterThanThreshold": "Шум перевищує порогове значення {value}{unit}",
  "alerts.noiseLessThan": "Шум менше ніж",
  "alerts.noiseLessThanThreshold": "Шум менше порогового значення {value}{unit}",
  "alerts.noteOnConditions": "Зауважте, що сповіщення спрацьовує, коли перевіряються всі наведені нижче умови",
  "alerts.pm10GreaterThan": "PM 10 більше ніж",
  "alerts.pm10GreaterThanThreshold": "PM 10 перевищує порогове значення {value}{unit}",
  "alerts.pm10LessThan": "PM 10 менше ніж",
  "alerts.pm10LessThanThreshold": "PM 10 менше за порогове значення {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 більше ніж",
  "alerts.pm1GreaterThanThreshold": "PM 1 перевищує порогове значення {value}{unit}",
  "alerts.pm1LessThan": "PM 1 менше ніж",
  "alerts.pm1LessThanThreshold": "PM 1 менше за порогове значення {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 більше ніж",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 перевищує порогове значення {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 менше ніж",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 менше ніж порогове значення {value}{unit}",
  "alerts.postStormSummary": "Підсумок після дощу",
  "alerts.postStormSynopsisHelper": "Ви отримаєте сповіщення з підсумком після завершення кожного дощу.",
  "alerts.postStormSynopsisSoleCondition": "Підсумок після грози не можна поєднувати з іншими умовами.",
  "alerts.precipitationGreaterThan": "Годинні опади більше ніж",
  "alerts.precipitationGreaterThanThreshold": "Годинні опади перевищують поріг {value}{unit}",
  "alerts.pressureGreaterThan": "Тиск більше ніж",
  "alerts.pressureGreaterThanThreshold": "Тиск перевищує порогове значення {value}{unit}",
  "alerts.pressureLessThan": "Тиск менше ніж",
  "alerts.pressureLessThanThreshold": "Тиск менший за порогове значення {value}{unit}",
  "alerts.rainRateGreaterThan": "Інтенсивність дощу більше ніж",
  "alerts.rainRateGreaterThanThreshold": "Інтенсивність дощу перевищує поріг {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Сонячна радіація більше ніж",
  "alerts.solarRadiationGreaterThanThreshold": "Сонячна радіація перевищує порогове значення {value}{unit}",
  "alerts.solarRadiationLessThan": "Сонячна радіація менше ніж",
  "alerts.solarRadiationLessThanThreshold": "Сонячна радіація менша за порогове значення {value}{unit}",
  "alerts.temperatureGreaterThan": "Температура вище ніж",
  "alerts.temperatureGreaterThanThreshold": "Температура перевищує порогове значення {value}{unit}",
  "alerts.temperatureLessThan": "Температура менше ніж",
  "alerts.temperatureLessThanThreshold": "Температура нижча за порогове значення {value}{unit}",
  "alerts.thswGreaterThan": "THSW більший за",
  "alerts.thswGreaterThanThreshold": "THSW перевищує порогове значення {value}{unit}",
  "alerts.thswLessThan": "THSW менший за",
  "alerts.thswLessThanThreshold": "THSW нижчий за порогове значення {value}{unit}",
  "alerts.thwGreaterThan": "THW більший за",
  "alerts.thwGreaterThanThreshold": "THW перевищує порогове значення {value}{unit}",
  "alerts.thwLessThan": "THW менший за",
  "alerts.thwLessThanThreshold": "THW нижчий за порогове значення {value}{unit}",
  "alerts.uvGreaterThan": "УФ-індекс більше ніж",
  "alerts.uvGreaterThanThreshold": "УФ-індекс перевищує порогове значення {value}{unit}",
  "alerts.uvLessThan": "УФ-індекс менше ніж",
  "alerts.uvLessThanThreshold": "УФ-індекс менший за порогове значення {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимість перевищує порогове значення {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимість менше ніж порогове значення {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимість більше ніж",
  "alerts.visiblityLessThan": "Видимість менше ніж",
  "alerts.whichMeasure": "За який захід ви хотіли б отримати попередження?",
  "alerts.whichModule": "Який модуль ви хотіли б, щоб вас попереджали?",
  "alerts.windChillGreaterThan": "Вітер холодний більший за",
  "alerts.windChillGreaterThanThreshold": "Вітер холодний перевищує порогове значення {value}{unit}",
  "alerts.windChillLessThan": "Вітер холодний менший за",
  "alerts.windChillLessThanThreshold": "Вітер холодний нижчий за порогове значення {value}{unit}",
  "alerts.windSpeedGreaterThan": "Швидкість вітру більше ніж",
  "alerts.windSpeedGreaterThanThreshold": "Швидкість вітру перевищує порогове значення {value}{unit}",
  "alerts.windSpeedLessThan": "Швидкість вітру менше ніж",
  "alerts.windSpeedLessThanThreshold": "Швидкість вітру менша за порогове значення {value}{unit}",
  "astral.astronomicalSunPhase": "Астрономічний {sunPhase}",
  "astral.civilSunPhase": "Цивільна {sunPhase}",
  "astral.dawn": "Світанок",
  "astral.dusk": "Сутінки",
  "astral.firstQuarter": "Перша чверть",
  "astral.fullMoon": "Повний місяць",
  "astral.lastQuarter": "Остання чверть",
  "astral.moon": "Місяць",
  "astral.moonPhases": "Місячні фази",
  "astral.moonrise": "Схід місяця",
  "astral.moonset": "Захід місяця",
  "astral.nauticalSunPhase": "Морський {sunPhase}",
  "astral.newMoon": "Новий місяць",
  "astral.noon": "полудень",
  "astral.remainingDaylight": "Залишок денного світла",
  "astral.sunrise": "Схід сонця",
  "astral.sunriseAndSunset": "Схід і захід сонця",
  "astral.sunriseAt": "Схід сонця о {time}",
  "astral.sunset": "Захід сонця",
  "astral.sunsetAt": "Захід сонця о {time}",
  "astral.totalDaylight": "Загальний світловий день",
  "astral.waningCrescent": "Згасаючий півмісяць",
  "astral.waningGibbous": "Знижується гіббо",
  "astral.waxingCrescent": "Зростаючий півмісяць",
  "astral.waxingGibbous": "Воскова гібба",
  "auth.alreadyHaveAccount": "Вже маєте обліковий запис?",
  "auth.authContainerTagline": "Ваша персональна панель погоди. Підключіть свої станції та отримуйте дані в реальному часі під рукою.",
  "auth.backToLogin": "Повернутися до входу",
  "auth.catchPhrase": "Платформа Weather Intelligence",
  "auth.checkYourEmail": "Перевірте вашу електронну пошту",
  "auth.continueWithApple": "Продовжити з Apple",
  "auth.continueWithFacebook": "Продовжити з Facebook",
  "auth.continueWithGoogle": "Продовжити з Google",
  "auth.email": "Адреса електронної пошти",
  "auth.emailRequiredLoginFacebook": "Потрібен дозвіл електронної пошти.",
  "auth.emailVerification": "Підтвердження електронної пошти",
  "auth.emailVerificationFailure": "Виникла проблема з підтвердженням електронної пошти.",
  "auth.emailVerificationSuccess": "Вашу електронну адресу було успішно підтверджено.",
  "auth.firstName": "Ім'я",
  "auth.forgotPassword": "Забули свій пароль?",
  "auth.forgotPasswordSubtitle": "Введіть вашу електронну пошту, і ми надішлемо вам посилання для скидання пароля.",
  "auth.lastName": "Прізвище",
  "auth.login": "Логін",
  "auth.loginSubtitle": "З поверненням! Будь ласка, введіть свої дані.",
  "auth.loginToSmartMixinDescription": "Введіть свої облікові дані SmartMixin, щоб отримати доступ до свого облікового запису.",
  "auth.logout": "Вийти",
  "auth.logoutConfirmation": "Ви впевнені, що бажаєте вийти?",
  "auth.noAccountYet": "Ще немає облікового запису?",
  "auth.or": "або",
  "auth.password": "Пароль",
  "auth.passwordAgain": "Знову пароль",
  "auth.passwordReset": "Скидання пароля",
  "auth.passwordResetSuccess": "Ваш пароль успішно оновлено.",
  "auth.register": "Створити акаунт",
  "auth.registerDescription": "Створіть безкоштовний обліковий запис SmartMixin для підключення ваших метеостанцій, відстеження погодних даних та доступу до потужних аналітичних інструментів.",
  "auth.registerSubtitle": "Створіть обліковий запис, щоб почати.",
  "auth.registerSuccess": "Ви успішно зареєструвалися! Ми щойно надіслали вам посилання для підтвердження на адресу {emailAddress} із подальшими інструкціями.",
  "auth.restorePassword": "Відновити пароль",
  "auth.restorePasswordSuccess": "Ми щойно надіслали вам посилання для зміни пароля на адресу {emailAddress} із подальшими інструкціями.",
  "auth.sendReset": "Надіслати інструкції щодо скидання",
  "auth.socialAccount": "або скористайтеся своїм обліковим записом",
  "auth.welcome": "Ласкаво просимо до SmartMixin",
  "auth.welcomeBack": "З поверненням!",
  "calendar.april": "Квітень",
  "calendar.august": "Серпень",
  "calendar.dateFormat": "Формат дати",
  "calendar.day": "День",
  "calendar.december": "Грудень",
  "calendar.end": "Кінець",
  "calendar.february": "Лютий",
  "calendar.hours": "години",
  "calendar.hoursShort": "години",
  "calendar.january": "Січень",
  "calendar.july": "Липень",
  "calendar.june": "Червень",
  "calendar.last24Hours": "Останні 24 години",
  "calendar.last30Days": "Останні 30 днів",
  "calendar.last7Days": "Останні 7 днів",
  "calendar.march": "Березень",
  "calendar.max": "Макс",
  "calendar.may": "Травень",
  "calendar.month": "місяць",
  "calendar.months": "місяців",
  "calendar.november": "Листопад",
  "calendar.october": "Жовтень",
  "calendar.oneDay": "1-денний",
  "calendar.oneHour": "1-годинний",
  "calendar.oneMonth": "1 місяць",
  "calendar.oneWeek": "1 тиждень",
  "calendar.previous24Hours": "Попередні 24 години",
  "calendar.previous30Days": "Попередні 30 днів",
  "calendar.previous7Days": "Попередні 7 днів",
  "calendar.previousDay": "Попередній день",
  "calendar.previousMonth": "Попередній місяць",
  "calendar.previousWeek": "Попередній тиждень",
  "calendar.previousYear": "Попередній рік",
  "calendar.sameDayLastYear": "Той же день минулого року",
  "calendar.sameMonthLastYear": "Той самий місяць минулого року",
  "calendar.selectADate": "Виберіть дату",
  "calendar.selectAMonth": "Виберіть місяць",
  "calendar.selectAYear": "Виберіть рік",
  "calendar.selectGranularity": "Виберіть ступінь деталізації",
  "calendar.selectTimescale": "Виберіть шкалу часу",
  "calendar.september": "Вересень",
  "calendar.sixHours": "6-годинний",
  "calendar.start": "Початок",
  "calendar.thirtyMinutes": "30 хв",
  "calendar.threeHours": "3-годинний",
  "calendar.use24HourFormat": "Використовуйте 24-годинний формат",
  "calendar.week": "тиждень",
  "calendar.year": "рік",
  "calendar.yesterday": "вчора",
  "common.accountDeleted": "Ваш обліковий запис успішно видалено.",
  "common.accountOnHold": "З'єднання вашого облікового запису закінчилося. Будь ласка, підключіться знову, щоб відновити оновлення даних.",
  "common.add": "додати",
  "common.addAStation": "Додайте станцію",
  "common.addToFavorites": "Додати в обране",
  "common.addYourOwnStation": "Додайте власну станцію",
  "common.alreadyPremium": "У вас вже є преміум-акаунт!",
  "common.alsoAvailableOn": "Також доступно на:",
  "common.altitude": "Висота",
  "common.analysis": "Аналіз",
  "common.aroundMe": "Навколо мене",
  "common.articleCount": "{count, plural, one {count} стаття} few {count} статті} many {count} статей} other {count} статей}}",
  "common.articleNotFound": "Статтю не знайдено",
  "common.articleNotFoundDescription": "Стаття, яку ви шукаєте, не існує.",
  "common.average": "Середній",
  "common.averageOverThePeriod": "Середнє за період",
  "common.away": "геть",
  "common.back": "Назад",
  "common.backToHelpCenter": "Повернутися до довідкового центру",
  "common.backToHome": "Повернутися на Головну",
  "common.bad": "погано",
  "common.batteryLevel": "Рівень заряду батареї",
  "common.bestValue": "Найкраща Пропозиція",
  "common.billingDetailsAndroid": "У разі безкоштовної пробної пропозиції з вас не стягуватиметься плата, якщо ви скасуєте підписку за 24 години до закінчення безкоштовного вступного періоду. Коли пробна версія закінчиться, ви можете будь-коли скасувати підписку на SmartMixin у налаштуваннях облікового запису Google Play, або її буде автоматично поновлено. Це потрібно зробити за 24 години до закінчення періоду передплати, щоб уникнути додаткової комісії, зазначеної на кнопці вище. Платежі за підписку будуть стягнені з вашого облікового запису Google Play після підтвердження покупки та на початку кожного терміну поновлення.",
  "common.billingDetailsIos": "У разі безкоштовної пробної пропозиції з вас не стягуватиметься плата, якщо ви скасуєте підписку за 24 години до закінчення безкоштовного вступного періоду. Коли пробна версія закінчиться, ви можете будь-коли скасувати підписку на SmartMixin у налаштуваннях облікового запису App Store, або її буде автоматично поновлено. Це потрібно зробити за 24 години до закінчення періоду передплати, щоб уникнути додаткової комісії, зазначеної на кнопці вище. Платежі за підписку будуть стягнені з вашого облікового запису App Store після підтвердження покупки та на початку кожного терміну поновлення.",
  "common.boilerOn": "Котел ВКЛ",
  "common.browseByCategory": "Переглянути за категорією",
  "common.calendarView": "Перегляд календаря",
  "common.cancel": "Скасувати",
  "common.cannotBeEmpty": "Це поле не може бути порожнім.",
  "common.cardDetails": "Реквізити картки",
  "common.categoryNotFound": "Категорію не знайдено",
  "common.categoryNotFoundDescription": "Ця категорія не існує або не містить статей.",
  "common.charts": "Діаграми",
  "common.chartView": "Перегляд діаграми",
  "common.clearRecentLocations": "Очистити все",
  "common.close": "Закрити",
  "common.comparison": "Порівняння",
  "common.currentDay": "Поточний день",
  "common.currentLocation": "Поточне розташування",
  "common.currentObservations": "Сучасні спостереження",
  "common.currentRainEvent": "Поточний дощ",
  "common.currentRate": "Поточний курс",
  "common.currentWeatherConditions": "Поточні умови",
  "common.customizeComparisonMetrics": "Налаштування показників",
  "common.customizeComparisonMetricsDescription": "Перетягніть елементи, щоб переупорядкувати метрики порівняння. Торкніться значка ока, щоб показати або сховати показники.",
  "common.customizeDashboard": "Налаштувати",
  "common.customizeDashboardDescription": "Перетягніть елементи, щоб змінити порядок на панелі. Натисніть на іконку ока, щоб показати або приховати розділи.",
  "common.customizedStationName": "Індивідуальна назва станції",
  "common.dailyForecast": "Щоденний прогноз",
  "common.dashboard": "Панель приладів",
  "common.default": "За замовчуванням",
  "common.defaultForecastModelChip": "За замовчуванням · {name}",
  "common.delete": "Видалити",
  "common.deleteAccount": "Видалити обліковий запис",
  "common.deleteAccountConfirmation": "Ви впевнені, що хочете видалити свій обліковий запис? Ця дія незворотна.",
  "common.deleteAccountDescription": "Ця дія видаляє ваш обліковий запис і всю вашу інформацію. Дороги назад немає.",
  "common.details": "Подробиці",
  "common.edit": "Редагувати",
  "common.editor": "редактор",
  "common.endTime": "Час закінчення",
  "common.exitFullscreen": "Вийти з повноекранного режиму",
  "common.exploreWeatherMap": "Дослідити Карту Погоди",
  "common.favoriteLocations": "Фаворити",
  "common.favoriteLocationsEmpty": "Ви можете додати до 5 улюблених місць.",
  "common.favoriteStations": "Улюблені станції",
  "common.feedbackHelpsImprove": "Ваші відгуки допомагають нам покращувати довідкові статті.",
  "common.filterStationDescription": "Не показуйте станції з ненадійними показниками",
  "common.filterStations": "Фільтрувальні станції",
  "common.filterStationSourceDescription": "Виберіть постачальників станцій, які ви хочете відобразити на карті",
  "common.findStationsNearYou": "Знайти станції поблизу",
  "common.firmwareVersion": "Версія прошивки",
  "common.forecast": "Прогноз",
  "common.forecastComparisonDescription": "Легко порівнюйте результати моделі прогнозу з кількох джерел",
  "common.forecastModelComparison": "Порівняння моделі прогнозу",
  "common.forecastModelCoverage": "Охоплення",
  "common.forecastModelDescription": "Опис",
  "common.forecastModelDescription_AROME": "Високороздільна модель Météo France із розв'язанням конвекції над Західною Європою з роздільністю 1,3 км. Найкраща у своєму класі для короткострокових прогнозів у Франції; оновлюється кожні три години.",
  "common.forecastModelDescription_ARPEGE_EU": "Європейський вкладений домен моделі ARPEGE Météo France з роздільністю 10 км. Середньострокові прогнози над Європою, оновлюються чотири рази на день.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Глобальна чисельна модель погоди Météo France з роздільністю 25 км, працює до приблизно 4 днів. Оновлюється чотири рази на день.",
  "common.forecastModelDescription_EC_GDPS": "Глобальна детерміністична система прогнозування Environment Canada: всесвітня середньострокова модель з роздільністю 15 км, що працює до 10 днів, оновлюється двічі на день.",
  "common.forecastModelDescription_EC_RDPS": "Регіональна детерміністична система прогнозування Environment Canada: середньострокова модель над Північною Америкою з роздільністю 10 км, оновлюється чотири рази на день.",
  "common.forecastModelDescription_GFS": "Флагманська середньострокова глобальна модель NOAA. Охоплює всю планету з роздільністю 25 км до 16 днів, оновлюється чотири рази на день.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh від NOAA: модель із розв'язанням конвекції над континентальною частиною США з роздільністю 3 км, оновлюється щогодини. Найкраще підходить для дуже короткострокових прогнозів гроз і сильної погоди.",
  "common.forecastModelDescription_ICON_DE": "Високороздільна модель DWD із розв'язанням конвекції над Німеччиною та сусідніми країнами з роздільністю 2,2 км. Короткострокові прогнози оновлюються двічі на день.",
  "common.forecastModelDescription_ICON_EU": "Європейський вкладений домен моделі ICON DWD з роздільністю 7 км, що охоплює Європу та Північну Атлантику. Середньострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_MET_NORWAY": "Відкрита служба прогнозу погоди Норвезького метеорологічного інституту, яка поєднує високороздільні скандинавські моделі з даними ECMWF для надання глобальних прогнозів на термін до 10 днів.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Вкладений домен AROME над французькими Антильськими островами (Гваделупа, Мартиніка) з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Вкладений домен AROME над Французькою Гвіаною з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Вкладений домен AROME над Новою Каледонією з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Вкладений домен AROME над Французькою Полінезією з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Вкладений домен AROME над Реюньйоном та Майотою з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_NAM_CONUS": "Вкладений домен моделі North American Mesoscale NOAA над континентальною частиною США з роздільністю 5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Модель North American Mesoscale NOAA, що охоплює всю Північну Америку з роздільністю 32 км. Оновлюється чотири рази на день.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Флагманський прогноз SmartMixin. Для кожної години у вашому місцезнаходженні ми вибираємо найкращу доступну модель — зазвичай високороздільну регіональну модель там, де така існує (AROME у Франції, ICON-D2 у Німеччині, HRRR у США, ARPEGE Europe по всьому континенту…) і повертаємось до глобальної моделі в інших місцях — потім заповнюємо будь-які прогалини з сусідніх джерел. Результат — єдиний безшовний прогноз, що охоплює будь-яке місце у світі на термін до 14 днів, автоматично оновлюється щоразу, коли оновлюється будь-яка з базових моделей.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Власний глобальний прогноз Weatherflow, що поєднує кілька чисельних моделей погоди зі спостереженнями з його мережі метеостанцій Tempest. 10-денний глобальний горизонт.",
  "common.forecastModelDetailTitle": "Прогнозна модель",
  "common.forecastModelScopeGlobal": "Глобальна",
  "common.forecastModelScopeGlobalDescription": "Ця модель охоплює всю планету.",
  "common.forecastModelScopeRegional": "Регіональна",
  "common.forecastModelScopeRegionalDescription": "Ця модель охоплює лише певний регіон.",
  "common.forecastModelSpecifications": "Характеристики",
  "common.forecastSources": "Джерела прогнозу",
  "common.freeAccount": "Безкоштовний акаунт",
  "common.freeSubscription": "Безкоштовна преміум-підписка",
  "common.freeTrialForPeriod": "Безкоштовна пробна версія протягом {period} днів",
  "common.frequency": "Частота",
  "common.full": "Повний",
  "common.fullscreen": "Повноекранний режим",
  "common.getStartedFree": "Почати Безкоштовно",
  "common.getUnlimitedAccess": "Необмежений доступ до:",
  "common.good": "добре",
  "common.hail": "Град",
  "common.help": "Довідка",
  "common.helpCategoryAccount": "Обліковий запис",
  "common.helpCategoryBilling": "Оплата",
  "common.helpCategoryGettingStarted": "Початок роботи",
  "common.helpCategoryProviders": "Постачальники",
  "common.helpCategoryStations": "Станції",
  "common.helpCategoryTroubleshooting": "Усунення неполадок",
  "common.helpCenter": "Довідковий центр",
  "common.helpCenterDescription": "Знайдіть відповіді на поширені запитання та дізнайтеся, як отримати максимум від SmartMixin.",
  "common.hg": "Морозохоронець",
  "common.hidden": "Приховані",
  "common.hiddenSensors": "Приховані датчики",
  "common.hiddenStations": "Приховані станції",
  "common.hiddenStationsDescription": "Ви можете порізати станцію, натиснувши піктограму очей поруч.",
  "common.high": "Високий",
  "common.home": "додому",
  "common.homeConnectService": "Маєте метеостанцію? Підключіть свій сервіс",
  "common.homeInformation": "Домашня інформація",
  "common.homeIntroduction": "Почніть підключати свої зовнішні облікові записи, щоб користуватися функціями SmartMixin.",
  "common.homeName": "Домашня назва",
  "common.homeSubtitle": "Ваша погода — все в одному місці",
  "common.horizon": "Горизонт",
  "common.horizonValue": "до {value} год",
  "common.iDontKnowYet": "я ще не знаю",
  "common.indoor": "закритий",
  "common.lastRainEvent": "Останній дощ",
  "common.lastUpdate": "Останнє оновлення",
  "common.legendHeavy": "Сильний",
  "common.legendLight": "Слабкий",
  "common.legendLightningHelp": "Колір показує вік кожної блискавки за останні {minutes} хвилин — найновіші білим, найстаріші темно-червоним.",
  "common.legendNewest": "Найновіші",
  "common.legendOldest": "Найстаріші",
  "common.legendStationsHelp": "Колір позначки відображає значення вибраного показника.",
  "common.lightningDataAttribution": "Дані про блискавки: Blitzortung.org",
  "common.lightningStrikes": "Удари блискавок",
  "common.lightningStrikesDescription": "Показувати удари блискавок на карті в реальному часі",
  "common.loading": "Завантаження",
  "common.location": "Місцезнаходження",
  "common.locationAddedToFavorites": "Місцезнаходження додається до улюблених",
  "common.locationNotGranted": "Дозвіл на розташування не надається. Будь ласка, дозвольте отримати доступ до свого місцезнаходження в налаштуваннях пристрою.",
  "common.locationRemovedFromFavorites": "Розташування видалено з фаворитів",
  "common.locations": "Розташування",
  "common.low": "Низький",
  "common.manage": "Керувати",
  "common.manageAccount": "Керувати обліковим записом",
  "common.manageMySubscription": "Керувати моєю підпискою",
  "common.manageSensors": "Керування датчиками",
  "common.manageSensorsDescription": "Перетягніть елементи для зміни порядку датчиків. Натисніть на іконку ока, щоб показати або приховати датчики. Натисніть на назву, щоб перейменувати.",
  "common.manualBoost": "Ручне підвищення",
  "common.manualSetpointUntil": "Ручне задане значення до",
  "common.mapLayers": "Шари карти",
  "common.mapLegend": "Легенда карти",
  "common.maxFavoriteLocationsReached": "Ви можете мати лише до 5 улюблених місць. Вийміть один, щоб додати інший.",
  "common.measureToDisplay": "Виміряти для відображення",
  "common.medium": "Середній",
  "common.meshSize": "Розмір сітки",
  "common.minRead": "{minutes} хв читання",
  "common.modifyFavoriteStations": "Змініть улюблені станції",
  "common.modifyFavoriteStationsDescription": "Ви можете переробити свої улюблені станції, перетягнувши їх. Ви також можете видалити їх зі списку.",
  "common.moduleType": "Тип модуля",
  "common.monthTotal": "Усього за місяць",
  "common.more": "більше",
  "common.moreInformation": "Більше інформації",
  "common.myLocation": "Моє місцезнаходження",
  "common.nearbyWeatherStations": "Поблизу погодних станцій",
  "common.next": "Наступний",
  "common.nextHours": "Наступні години",
  "common.no": "Немає",
  "common.noAccountNeeded": "Обліковий запис не потрібен",
  "common.noDataForThisPeriod": "Немає даних за цей період",
  "common.noLocationsFound": "Місця не знайдено",
  "common.noNetatmoWeatherStationYet": "У вас ще немає метеостанції Netatmo.",
  "common.noOutdoorModule": "Функціонального зовнішнього модуля для цієї станції немає.",
  "common.noStationsFound": "Станції не знайдено",
  "common.noThermostatYet": "У вас ще немає термостата.",
  "common.notNow": "Не зараз",
  "common.notPurchasedYet": "Здається, це ще не куплено.",
  "common.noWeatherStation": "Немає метеостанції",
  "common.noWeatherStationYet": "У вас ще немає метеостанції.",
  "common.numberOfActiveWarnings": "{warning_count} aктивні погодні попередження",
  "common.openSettings": "Відкриті налаштування",
  "common.orChooseMonthly": "Або оберіть щомісячно:",
  "common.outdatedModule": "Дані для цього модуля застаріли.",
  "common.outdoor": "Відкритий",
  "common.outdoorTemperature": "Зовнішня температура",
  "common.pageNotFound": "Сторінку Не Знайдено",
  "common.pageNotFoundDescription": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
  "common.passwordUpdated": "Пароль успішно оновлено.",
  "common.personalWeatherIntelligence": "Ваш Персональний Погодний Інтелект",
  "common.premiumAccount": "Преміум акаунт",
  "common.premiumDescription": "Преміум-підписка відкриває багато додаткових функцій, таких як розширений аналіз погоди, порівняння карт, моделі регіонального прогнозу та багато іншого.",
  "common.premiumFeatureAlerts": "Погодні Сповіщення",
  "common.premiumFeatureAnalysis": "Розширений Аналіз Погоди",
  "common.premiumFeatureCharts": "Порівняння Графіків",
  "common.premiumFeatureExport": "Експорт Даних",
  "common.premiumFeatureForecast": "Регіональні Моделі Прогнозів",
  "common.premiumFeatureNotification": "Віджет Рядка Стану",
  "common.premiumFeatureTitle": "Преміум Функція",
  "common.premiumFeatureWidgets": "Віджети головного екрану",
  "common.pressureSummary": "Підсумок тиску",
  "common.previous": "Попередній",
  "common.previousHours": "Попередні години",
  "common.profileUpdated": "Профіль успішно оновлено.",
  "common.purchasedNetatmoPro": "Раніше ви придбали Netatmo Pro ({date}). Це дає вам доступ до набору преміум-функцій. Підпишіться на одну з наведених нижче пропозицій, якщо хочете мати доступ до всіх преміум-функцій.",
  "common.radarDataAttribution": "Дані радара: RainViewer.com",
  "common.rain": "Дощ",
  "common.rainEvents": "Дощові події",
  "common.rainfallMeasurement": "Вимірювання кількості опадів",
  "common.rainRadar": "Радар дощу",
  "common.rainRadarDescription": "Відображення накладення радара дощу на карті",
  "common.rainSummary": "Зведення дощу",
  "common.range": "Діапазон",
  "common.recentLocations": "Недавній",
  "common.recentLocationsEmpty": "Ви недавня історія порожня.",
  "common.recentStations": "Останні станції",
  "common.relatedArticles": "Пов'язані статті",
  "common.relay": "естафета",
  "common.removeFromFavorites": "Видалити з вибраного",
  "common.renameSensors": "Перейменувати датчики",
  "common.resetZoom": "Скинути масштаб",
  "common.restorePurchase": "Відновити покупку",
  "common.room": "Кімната",
  "common.rooms": "Кімнати",
  "common.savingsPercent": "Економія {percent}%",
  "common.searchArticles": "Пошук статей...",
  "common.searchForALocation": "Пошук місця...",
  "common.searchForLocation": "Пошук місця",
  "common.searchForWeatherStation": "Пошук метеостанції",
  "common.searchResults": "Результати пошуку",
  "common.searchResultsEmpty": "Жодних результатів не знайдено.",
  "common.searchStationsDescription": "Введіть місто, адресу або назву місця, щоб знайти метеостанції поблизу.",
  "common.searchStationsHint": "Використовуйте рядок пошуку вище, щоб знайти метеостанції в будь-якій точці світу.",
  "common.selectStationForComparison": "Виберіть станцію для порівняння",
  "common.selectWeatherForecastProvider": "Виберіть постачальника погоди",
  "common.serialNumber": "Серійний номер",
  "common.share": "Поділіться",
  "common.shareOutdoorMeasures": "Поділіться своїми заходами на природі",
  "common.shareOutdoorMeasuresDescription": "Беріть участь у спільноті SmartMixin, показуючи іншим свої заходи на відкритому повітрі. Внутрішні заходи ніколи не будуть передані.",
  "common.shareYourWeather": "Поділіться своєю погодою",
  "common.signalStrength": "Сила сигналу",
  "common.skip": "Пропустити",
  "common.smartThermostat": "Розумний термостат",
  "common.smartValve": "Розумний клапан",
  "common.snow": "Сніг",
  "common.start": "Почати",
  "common.startFreeTrial": "Почати Безкоштовну Пробну Версію",
  "common.startTime": "Час початку",
  "common.station": "станція",
  "common.stationAddedToFavorites": "Станція додана до вибраного",
  "common.stationComparison": "Порівняння станцій",
  "common.stationComparisonDescription": "Порівняйте історичні дані погоди з іншою станцією",
  "common.stationInformation": "Інформація про станцію",
  "common.stationName": "Назва станції",
  "common.stationObservationsDescription": "Показувати останні спостереження з метеостанцій",
  "common.stationRemovedFromFavorites": "Станцію видалено з вибраного",
  "common.stations": "станції",
  "common.stationsNear": "Станції поблизу",
  "common.stationType": "Тип станції",
  "common.statusOffline": "Поза мережею",
  "common.statusOnline": "В мережі",
  "common.statusStale": "Застаріле",
  "common.statusSyncing": "Синхронізація",
  "common.subscribeNow": "Підписатися зараз - без пробного періоду",
  "common.sumOverThePeriod": "Накопичено за період",
  "common.switchToPremium": "Перейдіть на SmartMixin Premium",
  "common.temperatureShort": "Темп.",
  "common.temperatureSummary": "Зведення по температурі",
  "common.thankYouForFeedback": "Дякуємо за ваш відгук!",
  "common.thenPrice": "потім {price}",
  "common.timeSelection": "Вибір часу",
  "common.timezone": "Часовий пояс",
  "common.totalDuration": "Загальна тривалість",
  "common.tryAnotherLocation": "Ми не змогли знайти метеостанції поблизу цього місця. Спробуйте пошукати в іншому районі.",
  "common.unknown": "Невідомий",
  "common.untilChanged": "До зміни",
  "common.untilTime": "До {time}",
  "common.upgrade": "Оновлення",
  "common.upgradeRequiredAndroid": "Необхідно оновити вашу програму. Щоб оновити, відвідайте Google Play.",
  "common.upgradeRequiredIos": "Необхідно оновити вашу програму. Щоб оновити, відвідайте App Store.",
  "common.validate": "Перевірити",
  "common.validEmail": "Потрібна дійсна адреса електронної пошти.",
  "common.very_low": "Дуже низький",
  "common.visitNetatmoWebsite": "Відвідайте сайт Netatmo",
  "common.wasArticleHelpful": "Чи була ця стаття корисною?",
  "common.weatherCondition": "Умови погоди",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain — це додаткове джерело даних, яке надається через систему Tempest Weather System на основі технології Nearcast. Дані NC Rain – це оцінка середньої кількості опадів навколо вашого Tempest на рівні околиць",
  "common.weatherForecastModels": "Моделі прогнозу погоди",
  "common.weatherIntelligencePlatform": "Платформа Погодного Інтелекту",
  "common.weatherMap": "Карта погоди",
  "common.weatherMapMetaDescription": "SmartMixin пропонує інтерактивні карти погоди та радарні карти для метеорологічних умов по всьому світу.",
  "common.weatherObservations": "Спостереження за погодою",
  "common.weatherStation": "Метеостанція",
  "common.weatherStations": "Метеостанції",
  "common.welcome": "Ласкаво просимо до SmartMixin!",
  "common.whenBackHome": "Коли ти повернешся додому?",
  "common.wifiStrength": "Потужність WiFi",
  "common.wind": "Вітер",
  "common.windMeasurement": "Вимірювання вітру",
  "common.windSpeed": "Швидкість вітру",
  "common.windSummary": "Вітер короткий зміст",
  "common.yearToDate": "Рік до сьогодні",
  "common.yes": "Так",
  "intro.locationDescription": "Дозвольте доступ до місцезнаходження, щоб отримувати точні прогнози, адаптовані до вашої локації — ніяких більше загальних прогнозів.",
  "intro.locationTitle": "Прогнози, створені для вас",
  "intro.notificationDescription": "Увімкніть сповіщення, щоб отримувати своєчасні попередження про важливі для вас зміни погоди — дощ, сніг чи екстремальні умови саме тоді, коли це потрібно.",
  "intro.notificationsTitle": "Не пропускайте зміни погоди",
  "intro.readyDescription": "Насолоджуйтеся точними прогнозами, актуальними даними про погоду та інформацією зі станцій по всьому світу — в одному потужному застосунку.",
  "intro.readyTitle": "Усе готово!",
  "intro.welcomeDescription": "Отримуйте гіперлокальні прогнози від провідних метеоагентств — а також доступ до понад 40 000 метеостанцій по всьому світу, щоб бачити реальні умови, минулі та теперішні.",
  "intro.welcomeTitle": "Ваш прогноз погоди, переосмислений",
  "landing.alerts": "Оповіщення",
  "landing.alertsDescription": "Створюйте власні сповіщення та отримуйте сповіщення, щойно вони спрацюють.",
  "landing.featureAlertsDescription": "Налаштуйте власні сповіщення для умов, які вас цікавлять—температура, вітер, опади та інше.",
  "landing.featureAlertsTitle": "Розумні сповіщення",
  "landing.featureAnalyticsDescription": "Зануртеся у свої дані з інтерактивними графіками, порівняннями пліч-о-пліч та аналізом трендів за межами базових метрик.",
  "landing.featureAnalyticsTitle": "Потужна аналітика",
  "landing.featureExportDescription": "Завантажуйте свої дані у форматі CSV для аналізу в Excel, інтеграції з іншими системами або резервного копіювання.",
  "landing.featureExportTitle": "Експорт куди завгодно",
  "landing.featureForecastDescription": "Порівняйте прогнози з понад 10 погодних моделей, включаючи GFS, ECMWF, ICON та інші, щоб побачити, яка краще працює для вашої локації.",
  "landing.featureForecastTitle": "Порівняння прогнозів",
  "landing.featureHistoryDescription": "Доступ до історичних даних з погодинною, денною та місячною шкалою. Експорт у CSV для досліджень або особистих архівів.",
  "landing.featureHistoryTitle": "Багата історія",
  "landing.featureMultiBrandDescription": "Підключіть станції від Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow та інших—усе на одній панелі.",
  "landing.featureMultiBrandTitle": "Підтримка багатьох брендів",
  "landing.featuresSubtitle": "Створено для ентузіастів погоди, яким потрібно більше, ніж базовий додаток метеостанції.",
  "landing.featuresTitle": "Усе, що потрібно для аналізу погоди",
  "landing.finalCtaButton": "Створити безкоштовний акаунт",
  "landing.finalCtaSubtitle": "Приєднуйтесь до тисяч ентузіастів погоди, які довіряють SmartMixin свої погодні дані.",
  "landing.finalCtaTitle": "Готові покращити свій погодний досвід?",
  "landing.forecastDescription": "Отримайте доступ до деяких із найкращих моделей прогнозу погоди та порівняйте їх, щоб отримати власне уявлення про те, якою буде погода.",
  "landing.forecasts": "Прогнози",
  "landing.heroCta": "Почати безкоштовно",
  "landing.heroDescription": "Об'єднайте декілька метеостанцій будь-яких брендів, порівнюйте моделі прогнозів та аналізуйте свої дані за допомогою детальних графіків та експорту.",
  "landing.heroSecondaryCta": "Переглянути функції",
  "landing.heroTagline": "Ваш персональний помічник",
  "landing.heroTitle": "Усі погодні дані. Одна платформа.",
  "landing.pricingFeatureAdvancedMetrics": "Розширені метрики",
  "landing.pricingFeatureAlerts": "Власні сповіщення",
  "landing.pricingFeatureExport": "Експорт даних (CSV)",
  "landing.pricingFeatureForecastComparison": "Порівняння прогнозів",
  "landing.pricingFeatureForecasts": "Моделі прогнозів",
  "landing.pricingFeatureForecastsFreeTier": "1 модель",
  "landing.pricingFeatureForecastsPremiumTier": "Усі моделі (10+)",
  "landing.pricingFeatureReports": "Аналіз та звіти",
  "landing.pricingFeatureStationComparison": "Порівняння станцій",
  "landing.pricingFeatureWidgets": "Віджети головного екрана",
  "landing.pricingFeatureYearOverYear": "Аналіз рік до року",
  "landing.pricingFree": "Безкоштовно",
  "landing.pricingFreeCta": "Почати",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Найпопулярніший",
  "landing.pricingPremium": "Преміум",
  "landing.pricingPremiumCta": "Почати",
  "landing.pricingPremiumDescription": "Від 1,99 €/місяць — підпишіться на сайті, в App Store або Google Play",
  "landing.pricingSubtitle": "Почніть безкоштовно, перейдіть на платну версію коли знадобиться більше.",
  "landing.pricingTitle": "Прості, прозорі ціни",
  "landing.smartMixinDescription": "SmartMixin — це програма, яка забезпечує доступ до вашої метеостанції та понад 40 тисяч інших станцій у всьому світі. Це допомагає вам бачити та розуміти дані про погоду.",
  "landing.statBrands": "Брендів",
  "landing.statForecasts": "Моделей прогнозів",
  "landing.statStations": "Підключених станцій",
  "landing.supportedDevices": "Підтримувані пристрої",
  "landing.supportedDevicesDescription": "Крім станцій Всесвітньої метеорологічної організації, SmartMixin підтримує все більше брендів метеостанцій.",
  "landing.supportedDevicesNote": "Функціонує з вашими станціями",
  "landing.supportedDevicesSubtitle": "Підключіть метеостанції провідних брендів та переглядайте всі дані в одному місці.",
  "landing.supportedDevicesTitle": "Працює з вашими станціями",
  "landing.thermostatDescription": "Підключіть термостат Netatmo для порівняння режимів опалення з умовами на вулиці.",
  "landing.thermostatManufacturers": "Виробники термостатів також можуть співвідносити опалення з зовнішніми умовами.",
  "landing.thermostatTitle": "Інтеграція з розумним домом",
  "landing.weatherAnalysis": "Аналіз погоди",
  "landing.weatherAnalysisDescription": "SmartMix постачається з великою кількістю візуалізації даних, яка дозволяє аналізувати дані про погоду.",
  "landing.weatherAssistant": "Ваш погодний помічник",
  "landing.weatherAssistantDescription": "Незалежно від того, чи цікавитеся ви поточними, історичними чи прогнозованими погодними умовами, SmartMixin надає численні відомості, коли вони вам потрібні.",
  "landing.weatherForecastModels": "Моделі прогнозу погоди",
  "landing.weatherForecastModelsDescription": "SmartMixin надає доступ до найточніших моделей прогнозу погоди. Ви можете легко порівняти їхні прогнози та скласти власну ідею.",
  "landing.weatherMap": "Карта погоди",
  "landing.weatherMapDescription": "Переглядайте карту та візуалізуйте, яка погода в будь-якій точці земної кулі.",
  "network.cancelError": "Запит скасовано",
  "network.connectionError": "Сервер недоступний",
  "network.networkError": "Мережа недоступна",
  "network.serverError": "Щось пішло не так...",
  "network.timeoutError": "Час очікування підключення",
  "network.unknownError": "Невідома помилка",
  "providerHints.ambientWeatherApiKey": "Створено в налаштуваннях облікового запису на ambientweather.net.",
  "providerHints.davisApiSecret": "Показується лише один раз при створенні ключа V2 API — зберігайте у надійному місці.",
  "providerHints.davisV2ApiKey": "Зі сторінки ключів V2 API на weatherlink.com.",
  "providerHints.ecowittApi": "Зі сторінки API вашого облікового запису Ecowitt.",
  "providerHints.ecowittApp": "Ключ застосунку, також із вашого облікового запису Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Використовуйте email і пароль облікового запису My AcuRite — не вхід у SmartMixin.",
  "providerHints.myAcuriteEmail": "Електронна пошта вашого облікового запису My AcuRite — не ваш вхід у SmartMixin.",
  "providerHints.myAcuritePassword": "Пароль вашого облікового запису My AcuRite.",
  "providerHints.weatherflowToken": "Особистий токен із tempestwx.com → налаштування → авторизації даних.",
  "providerHints.wundergroundEditKey": "Використати інший ключ",
  "providerHints.wundergroundKey": "Довгий рядок зі сторінки API-ключів вашого облікового запису Weather Underground — не ваш пароль на wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-ключ підтверджено",
  "providerHints.wundergroundKeyVerifying": "Перевірка ключа…",
  "providerHints.wundergroundNoStationsNearby": "Поблизу цього місця не знайдено станцій. Спробуйте ввести ID станції безпосередньо.",
  "providerHints.wundergroundStationId": "Будь-який ідентифікатор станції Weather Underground — ваш або публічної станції поруч.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Отримайте свій API-ключ Ambient Weather.",
  "providerIntro.davisStep2": "Отримайте свій ключ V2 API і API-секрет Davis.",
  "providerIntro.ecowittStep2": "Отримайте свій API-ключ і ключ застосунку Ecowitt.",
  "providerIntro.getStarted": "Почати",
  "providerIntro.myAcuriteStep2": "Використовуйте email і пароль вашого наявного облікового запису My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Увійдіть у Netatmo за запитом — API-ключ не потрібен.",
  "providerIntro.netatmoWeatherStep2": "Увійдіть у Netatmo за запитом — API-ключ не потрібен.",
  "providerIntro.signupBanner": "Майже готово — створіть безкоштовний обліковий запис SmartMixin, щоб підключити {provider}.",
  "providerIntro.step1": "Увійдіть у свій обліковий запис SmartMixin (НЕ у {provider}).",
  "providerIntro.step3EmailPassword": "Введіть їх тут.",
  "providerIntro.step3KeyOrToken": "Вставте сюди.",
  "providerIntro.step3OAuth": "Авторизуйте SmartMixin у спливаючому вікні.",
  "providerIntro.step3Wunderground": "Вставте свій API-ключ, потім виберіть найближчу станцію або введіть будь-який ID станції.",
  "providerIntro.title": "Підключити {provider}",
  "providerIntro.weatherflowStep2": "Отримайте свій особистий токен Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Не маєте станції? Перегляньте публічні",
  "providerIntro.wundergroundFindNearby": "Знайти станції поблизу",
  "providerIntro.wundergroundOrEnterId": "Або введіть ID станції",
  "providerIntro.wundergroundStep2": "Отримайте свій API-ключ Weather Underground. Потім ви зможете підключити будь-яку станцію — свою або публічну.",
  "reports.agroMeteorology": "Агрометеорологія",
  "reports.analysis": "Аналіз",
  "reports.annualCumulativeRainfallComparison": "Порівняння річної сумарної кількості опадів",
  "reports.annualHeatingDurationComparison": "Порівняння річної тривалості опалення",
  "reports.annualHeatingEfficiency": "Річна ефективність опалення",
  "reports.annualIndoorComparison": "Щорічне порівняння в приміщенні",
  "reports.annualIndoorReport": "Річний звіт про приміщення",
  "reports.annualOutdoorComparison": "Щорічне порівняння на відкритому повітрі",
  "reports.annualOutdoorReport": "Річний зовнішній звіт",
  "reports.annualReport": "Річний звіт",
  "reports.annualSolarReport": "Річний сонячний звіт",
  "reports.annualWaterBalance": "Річний водний баланс",
  "reports.annualWaterBalanceCarryOver": "Перенести з попереднього року",
  "reports.annualWaterBalanceDescription": "Водний баланс (спрощена версія, використовується лише дощ і випаровування) допомагає керувати водопостачанням",
  "reports.avgHumidity": "Середня вологість",
  "reports.avgMaxTemperature": "Середня T°макс",
  "reports.avgMinTemperature": "Середня T°min",
  "reports.avgPressure": "Середній тиск",
  "reports.avgTemperature": "Середня температура",
  "reports.comfortable": "Комфортно (45% {lessThan} вологість ≤ 60%)",
  "reports.cumulativeRainfall": "Сумарні опади",
  "reports.cumulativeRainfallDescription": "Відстежуйте загальну кількість опадів, накопичених за обраний період.",
  "reports.dailyMaxRainfall": "Макс. кількість опадів",
  "reports.dataExport": "Експорт даних",
  "reports.dataExportXlsxFormatDescription": "Експортуйте всі дані вашої станції у формат Excel (*.xlsx). Після натискання кнопки через кілька хвилин ви отримаєте електронний лист із обробленими даними.",
  "reports.daysWithFrost": "Дні з морозом",
  "reports.daysWithoutThaw": "Дні без відлиги",
  "reports.daysWithStrongFrost": "Дні з сильними морозами",
  "reports.emailSent": "На вашу поштову скриньку надіслано електронний лист",
  "reports.grasslandTemperatureSum": "Сума температур пасовища",
  "reports.grasslandTemperatureSumDescription": "Якщо сума {threshold} перевищена навесні, досягнуто стабільного початку вегетації (працює в Європі)",
  "reports.growingDegreeDays": "Градусо-дні росту",
  "reports.highPressure": "Антициклон (середній тиск ≥ 1013 мбар)",
  "reports.indoorReport": "Звіт про приміщення",
  "reports.keyFacts": "Ключові факти",
  "reports.longestRunOfRainyDays": "Найдовша серія дощових днів",
  "reports.longestRunWithoutRun": "Найдовша пробіжка без дощу",
  "reports.lowPressure": "Низький тиск (середній тиск {lessThan} 1013 мбар)",
  "reports.maxHumidity": "Максимальна вологість",
  "reports.maxPressure": "Максимальний тиск",
  "reports.maxPressureMagnitude24h": "Максимальна магнітуда (/24 год)",
  "reports.maxTemperature": "Максимальна температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимальна магнітуда (/24 год)",
  "reports.minHumidity": "Мінімальна вологість",
  "reports.minPressure": "Мінімальний тиск",
  "reports.minPressureMagnitude24h": "Мінімальна магнітуда (/24H)",
  "reports.minTemperature": "Мінімальна температура",
  "reports.minTempMagnitude24h": "Мінімальна магнітуда (/24H)",
  "reports.monthlyHeatingEfficiency": "Місячна ефективність опалення",
  "reports.monthlyIndoorReport": "Щомісячний звіт про приміщення",
  "reports.monthlyOutdoorReport": "Щомісячний зовнішній звіт",
  "reports.monthlyReport": "Місячний звіт",
  "reports.monthlySolarReport": "Місячний сонячний звіт",
  "reports.monthlyWindReport": "Місячний звіт про вітер",
  "reports.numberOfDays": "Кількість днів",
  "reports.outdoorReport": "Відкритий звіт",
  "reports.rainfall": "Опади",
  "reports.rainyDays": "Дощові дні",
  "reports.relativelyWet": "Відносно вологий (60% {lessThan} вологість ≤ 80%)",
  "reports.sendEmail": "Відправити лист",
  "reports.tooDry": "Занадто сухо (вологість ≤ 45%)",
  "reports.tooWet": "Занадто вологий (вологість {greaterThan} 80%)",
  "reports.tropicalNights": "Тропічні ночі",
  "reports.waterBalance": "Водний баланс",
  "reports.yearToDateTemperature": "Температура з початку року",
  "reports.yearToDateTemperatureComparison": "Порівняння температури за рік до дати",
  "sensors.aqiByChannel": "AQI за каналом",
  "sensors.bgtSensors": "Чорна куля та WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareAqi": "Порівняти AQI",
  "sensors.compareHumidity": "Порівняти вологість",
  "sensors.compareMoisture": "Порівняти вологість ґрунту",
  "sensors.comparePm25": "Порівняти PM2.5",
  "sensors.compareTemperatures": "Порівняти температури",
  "sensors.depthByChannel": "Глибина за каналом",
  "sensors.heatStressExtreme": "Екстремальний тепловий стрес",
  "sensors.heatStressModerate": "Помірний тепловий стрес",
  "sensors.heatStressNone": "Немає теплового стресу",
  "sensors.heatStressStrong": "Сильний тепловий стрес",
  "sensors.heatStressVeryStrong": "Дуже сильний тепловий стрес",
  "sensors.humidityByChannel": "Вологість за каналом",
  "sensors.indoorAirQuality": "Якість повітря в приміщенні",
  "sensors.indoorAirQualityPm": "PM2.5 та PM10 AQI",
  "sensors.indoorClimate": "Мікроклімат",
  "sensors.indoorCo2Levels": "Рівні CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура та вологість",
  "sensors.last24Hours": "24 години",
  "sensors.last30Days": "30 днів",
  "sensors.last7Days": "7 днів",
  "sensors.leafTemperatureByChannel": "Температура листя за каналом",
  "sensors.leafWetnessByChannel": "Вологість листя за каналом",
  "sensors.lightningSensor": "Блискавка",
  "sensors.moistureByChannel": "Вологість ґрунту за каналом",
  "sensors.noDataAvailable": "Дані відсутні",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 за каналом",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Оберіть канал",
  "sensors.sensorDetailDescription": "Перегляд історичних даних та тенденцій для каналів датчика.",
  "sensors.sensorHistory": "Історія датчика",
  "sensors.soilConductivityByChannel": "Провідність за каналом",
  "sensors.soilTemperatureByChannel": "Температура ґрунту за каналом",
  "sensors.strikesToday": "Удари сьогодні",
  "sensors.temperatureByChannel": "Температура за каналом",
  "settings.about": "про",
  "settings.aboutDescription": "Ліцензійна угода, політика конфіденційності",
  "settings.account": "Обліковий запис",
  "settings.accountDescription": "Профіль, зміна пароля",
  "settings.accountIntro": "Дані стосуються вашого облікового запису:",
  "settings.accountSection": "Обліковий запис",
  "settings.appearance": "Зовнішній вигляд",
  "settings.appearanceDescription": "Тема та параметри відображення",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Арабська",
  "settings.availableServices": "Доступні",
  "settings.bulgarian": "Болгарська",
  "settings.cannotDisconnectLastAccount": "Неможливо від'єднати єдиний метод входу. Спочатку додайте інший метод входу.",
  "settings.changeEmail": "Змінити електронну пошту",
  "settings.changePassword": "Змінити пароль",
  "settings.chartGestures": "Жести на діаграмах",
  "settings.chartGesturesDescription": "Проведення пальцем по діаграмах змінює період часу, зведення діаграм змінює масштаб часу",
  "settings.connect": "Підключити",
  "settings.connected": "Підключено",
  "settings.connectedAccounts": "Підключені облікові записи",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Підключено",
  "settings.connectedSince": "Підключено з {date}",
  "settings.connectionSuccess": "Акаунт {provider} успішно підключено",
  "settings.contactUs": "Зв'язатися з нами",
  "settings.contactUsDescription": "Отримайте допомогу або надішліть відгук",
  "settings.croatian": "Хорватська",
  "settings.currentPassword": "Поточний пароль",
  "settings.czech": "чеська",
  "settings.danish": "датська",
  "settings.dark": "Темна тема",
  "settings.dataDisplay": "Відображення даних",
  "settings.dateAndTime": "Дата і час",
  "settings.disconnect": "Від'єднати",
  "settings.disconnectConfirmation": "Ви впевнені, що хочете від'єднати свій акаунт {provider}?",
  "settings.disconnectionSuccess": "Акаунт {provider} успішно від'єднано",
  "settings.donateButton": "Зробити пожертву",
  "settings.donateDescription": "SmartMixin створює невелика команда. Якщо застосунок корисний для вас, ви можете підтримати його розвиток разовою пожертвою на будь-яку суму. Це подарунок — він не змінює ваш тариф і не відкриває жодних функцій.",
  "settings.donateSuccessBody": "Ваша пожертва допомагає SmartMixin працювати та ставати кращим. Ми щиро це цінуємо.",
  "settings.donateSuccessTitle": "Дякуємо за вашу підтримку!",
  "settings.donateTitle": "Підтримайте SmartMixin",
  "settings.dutch": "голландська",
  "settings.emailChange": "Змінити адресу електронної пошти",
  "settings.emailChangeConfirmation": "Підтвердження зміни електронної пошти",
  "settings.emailChangeFailure": "Посилання для зміни електронної пошти недійсне або закінчилося.",
  "settings.emailChangeSuccess": "Вашу електронну пошту успішно змінено на {newEmail}.",
  "settings.emailChangeVerificationSent": "Лист для підтвердження надіслано на вашу нову адресу електронної пошти. Перевірте вхідні повідомлення та натисніть на посилання, щоб підтвердити зміну.",
  "settings.english": "англійська",
  "settings.forecastModelOrderEmpty": "Порядок не збережено — за замовчуванням використовується GFS.",
  "settings.forecastModelOrderFreeHint": "Преміум-моделі потребують підписки SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Ми обираємо першу модель зі списку, яка покриває кожну станцію.",
  "settings.forecastModelOrderReset": "Скинути",
  "settings.forecastModelOrderTitle": "Модель прогнозу за замовчуванням",
  "settings.forecastModels": "Моделі прогнозу",
  "settings.forecastModelsDescription": "Перевпорядкувати за уподобанням",
  "settings.french": "французька",
  "settings.german": "Німецький",
  "settings.gestures": "Жести",
  "settings.greek": "Грецький",
  "settings.helpCenter": "Центр допомоги",
  "settings.helpCenterDescription": "Поширені запитання та інструкції",
  "settings.hungarian": "угорська",
  "settings.integrationsSection": "Інтеграції",
  "settings.italian": "італійська",
  "settings.japanese": "Японський",
  "settings.korean": "корейська",
  "settings.language": "Мова",
  "settings.languageDescription": "Бажана мова",
  "settings.light": "Світла тема",
  "settings.newEmailAddress": "Нова адреса електронної пошти",
  "settings.newPassword": "Новий пароль",
  "settings.newPasswordAgain": "Знову новий пароль",
  "settings.norwegian": "норвезька",
  "settings.notConnected": "Не підключено",
  "settings.notificationsSection": "Сповіщення",
  "settings.oldPassword": "Старий пароль",
  "settings.ongoingNotificationEnabled": "Увімкнути постійне сповіщення",
  "settings.ongoingNotificationMetrics": "Відображені показники",
  "settings.ongoingNotificationMetricsHint": "Перетягніть для зміни порядку вибраних показників",
  "settings.ongoingNotificationPermissionRequired": "Потрібен дозвіл на сповіщення",
  "settings.ongoingNotificationStation": "Метеостанція",
  "settings.passwordChange": "Зміна пароля",
  "settings.polish": "польський",
  "settings.portuguese": "португальська",
  "settings.preferencesSection": "Налаштування",
  "settings.premium": "Преміум",
  "settings.premiumActive": "Активна",
  "settings.premiumAnnualThenPrice": "Потім 9,99 €/рік",
  "settings.premiumAnnualTrialInfo": "Почніть з безкоштовного пробного періоду на {days} днів",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Розблокуйте преміум-функції",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Без підписки",
  "settings.premiumManageWebSubscription": "Керуйте підпискою, оновіть спосіб оплати або скасуйте.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Щорічно — 9,99 €/рік",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Щомісячно — 1,99 €/місяць",
  "settings.premiumSubscribeOnWeb": "Підпишіться зараз, щоб розблокувати всі преміум-функції.",
  "settings.premiumSubscriptionSuccess": "Вашу підписку активовано! Насолоджуйтесь усіма преміум-функціями.",
  "settings.premiumSubscriptionSuccessTitle": "Ласкаво просимо до Premium!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Політика конфіденційності",
  "settings.profile": "Профіль",
  "settings.russian": "російський",
  "settings.serbian": "сербська",
  "settings.settings": "Налаштування",
  "settings.slovak": "словацький",
  "settings.smallDecimals": "Малі десяткові",
  "settings.smallDecimalsDescription": "Відображати десяткові цифри меншим розміром",
  "settings.socialConnectionsIntro": "Підключіть свої соціальні акаунти для швидкого входу. Ви можете підключати або від'єднувати акаунти в будь-який час.",
  "settings.spanish": "Іспанська",
  "settings.statusBarWidget": "Віджет рядка стану",
  "settings.statusBarWidgetDescription": "Завжди видимі дані про погоду",
  "settings.subscriptionSection": "Підписка",
  "settings.supportSection": "Підтримка",
  "settings.swedish": "шведська",
  "settings.systemTheme": "Тема системи",
  "settings.termsOfService": "Умови використання",
  "settings.turkish": "Турецький",
  "settings.ukrainian": "українська",
  "settings.units": "одиниці",
  "settings.unitsDescription": "Одиниці вимірювання, що відображаються в додатку",
  "settings.update": "оновлення",
  "settings.updateYourProfile": "Оновіть свій профіль",
  "settings.weatherServices": "Метеорологічні сервіси",
  "settings.weatherServicesConnected": "{count, plural, =0 {Немає підключених сервісів} one {# сервіс підключено} few {# сервіси підключено} many {# сервісів підключено} other {# сервісів підключено}}",
  "settings.weatherServicesDescription": "Підключіть Netatmo, Davis, Weatherflow та інші",
  "settings.windDirectionConvention": "Стрілка напрямку вітру",
  "settings.windDirectionConventionDescription": "Оберіть відображення стрілок напрямку вітру",
  "settings.windDirectionMeteorological": "Напрямок джерела",
  "settings.windDirectionMeteorologicalDescription": "Стрілка вказує, звідки дме вітер (конвенція meteorological)",
  "settings.windDirectionOceanographic": "Напрямок потоку",
  "settings.windDirectionOceanographicDescription": "Стрілка вказує, куди дме вітер (конвенція oceanographic)",
  "units.absolutePressure": "Абсолютний тиск",
  "units.airDensity": "Щільність повітря",
  "units.airGap": "Повітряний зазор",
  "units.apparentTemperature": "Відчутна температура",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Середнє",
  "units.beaufort": "Бофорта",
  "units.blackGlobeTemperature": "Темп. чорної кулі",
  "units.boilerOn": "Котел ВКЛ",
  "units.co2": "CO2",
  "units.conductivity": "Провідність",
  "units.coolingDegreeDays": "Охолодження градус-днів",
  "units.dailyHeatingDuration": "Добова тривалість обігріву",
  "units.dailyPrecipitation": "Добові опади",
  "units.dailyRain": "Добові опади",
  "units.degreeDay": "Градусний день",
  "units.degreeDayShort": "DD",
  "units.depth": "Глибина",
  "units.depthSensors": "Датчики глибини",
  "units.dewPoint": "точка роси",
  "units.distance": "Відстань",
  "units.downTrend": "вниз",
  "units.E": "E",
  "units.E_long": "схід",
  "units.ENE": "ENE",
  "units.ENE_long": "Схід-Північний Схід",
  "units.ESE": "ESE",
  "units.ESE_long": "Схід-Південний Схід",
  "units.ET": "Евапотранспірація",
  "units.ETshort": "ET",
  "units.feelLike": "Відчуває, як",
  "units.feelsLike": "Відчуває, як",
  "units.footMile": "Фут, миля",
  "units.frostPoint": "Точка замерзання",
  "units.gust": "Порив",
  "units.heatIndex": "Індекс тепла",
  "units.heatingDegreeDays": "Градусодні опалення",
  "units.heatingPower": "Теплова потужність",
  "units.humidex": "Гумідекс",
  "units.humidity": "Вологість",
  "units.inch": "дюйм",
  "units.inchOfMercury": "Дюйм ртутного стовпчика",
  "units.kilometerPerHour": "Кілометрів на годину",
  "units.knot": "вузол",
  "units.last12Hours": "Останні 12 годин",
  "units.last24Hours": "Останні 24 години",
  "units.last3Hours": "Останні 3 години",
  "units.last6Hours": "Останні 6 годин",
  "units.lastHour": "Остання година",
  "units.lastLightningImpact": "Останній удар",
  "units.lastMeasure": "Остання міра",
  "units.leafSensors": "Датчики листя",
  "units.leafWetness": "Вологість листя",
  "units.lightningDistance": "Відстань",
  "units.lightningStrikeCount": "Підрахунок ударів блискавки",
  "units.lightningStrikeDistance": "Відстань удару блискавки",
  "units.max": "Макс.",
  "units.max_gust": "Макс. порив",
  "units.max_wind": "Макс. вітер",
  "units.meterKilometer": "Метр, кілометр",
  "units.meterPerSecond": "Метри в секунду",
  "units.milePerHour": "Милі на годину",
  "units.millibar": "Мілібар",
  "units.millimeter": "міліметр",
  "units.millimeterOfMercury": "Міліметр ртутного стовпчика",
  "units.min": "Хв.",
  "units.N": "Н",
  "units.N_long": "північ",
  "units.NE": "NE",
  "units.NE_long": "північний схід",
  "units.NNE": "NNE",
  "units.NNE_long": "Північно-Північний Схід",
  "units.NNW": "NNW",
  "units.NNW_long": "Північно-Північний Захід",
  "units.noise": "Шум",
  "units.normalizedHeatingCoefficient": "Нормований коефіцієнт нагрівання",
  "units.NW": "NW",
  "units.NW_long": "Північний захід",
  "units.O3": "Озон",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2,5",
  "units.precipitation": "Опади",
  "units.pressure": "Тиск",
  "units.rain": "Дощ",
  "units.rainRate": "Інтенсивність дощу",
  "units.referenceTemperature": "Еталонна температура",
  "units.relativePressure": "Відносний тиск",
  "units.S": "С",
  "units.S_long": "Південь",
  "units.SE": "SE",
  "units.SE_long": "південний схід",
  "units.setPoint": "Уставка",
  "units.snow": "Сніг",
  "units.snowfall": "Снігопад",
  "units.soilMoisture": "вологість",
  "units.soilSensors": "Датчики грунту",
  "units.solarEnergy": "Сонячна енергія",
  "units.solarRadiation": "Сонячна радіація",
  "units.speed": "швидкість",
  "units.SSE": "SSE",
  "units.SSE_long": "Південь-Південний Схід",
  "units.SSW": "SSW",
  "units.SSW_long": "Південь-Південний Захід",
  "units.stableTrend": "стабільний",
  "units.sum": "сума",
  "units.SW": "SW",
  "units.SW_long": "На південний захід",
  "units.temperature": "температура",
  "units.temperatureAndHumiditySensors": "Датчики температури та вологості",
  "units.temperatureSensors": "Датчики температури та вологості",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Сьогодні",
  "units.upTrend": "вгору",
  "units.uv": "УФ",
  "units.visibility": "Видимість",
  "units.W": "В",
  "units.W_long": "Захід",
  "units.wetBulbGlobeTemperature": "Темп. вологої кулі",
  "units.wetBulbTemperature": "Температура по вологому термометру",
  "units.wind": "Вітер",
  "units.windChill": "Вітер холодний",
  "units.windDirection": "Напрямок вітру",
  "units.windRun": "Вітровий біг",
  "units.windRunDescription": "Розбіг вітру - це загальна відстань, яку подолав вітер за певний період часу",
  "units.WNW": "WNW",
  "units.WNW_long": "Захід-Північний Захід",
  "units.WSW": "WSW",
  "units.WSW_long": "Захід-Південний Захід"
}
